// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Cxl6","inputWrap":"styles_inputWrap__3bNrg","input":"styles_input__1Uzxq"};